<template>
  <div id="timelogger" v-if="globals.timelogger.visible">

    <div class="dimmer" @click="closeTimelogger()"></div>

    <div class="popup">

      <template>

        <table class="timelogger-entries">
          <thead>
            <tr>
              <th>Dato</th>
              <th>Timer</th>
              <th>Opgave</th>
              <th>Arbejdstype</th>
              <th>Note</th>
              <th>Fakturérbar</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(entry,i) in globals.timelogger.addList" :key="i">
              <td>
                <div class="label">Dato</div>
                <input type="date" class="unstyled" v-model="entry.date">
              </td>
              <td>
                <div class="label">Timer</div>
                <input v-model.number="entry.hours" type="number" step=".25" min="0.25" max="24" placeholder="Timetal">
              </td>
              <td>
                <div v-if="false">
                  <select name="" id="" v-model="entry.project_key">
                    <option value="undefined">Vælg...</option>
                    <option :value="project['.key']" v-for="(project,i) in projects">
                      {{project.name}} - {{getClient(project['.key']).name}}
                    </option>
                  </select>
                </div>
                <div class="label">Opgave</div>
                <multiselect
                  :options="projectSelectOptions"
                  placeholder="Vælg..."
                  label="label"
                  track-by="value"
                  select-label="" selected-label="" deselect-label=""
                  :value="multiSelectGetOption(projectSelectOptions,'value',entry.project_key)"
                  @select="multiSelectOnSelect('project',$event,entry)"
                  :reset-after="false"
                ></multiselect>              
              </td>
              <td v-if="false">
                <template v-if="getClient(entry.project_key)">
                  {{getClient(entry.project_key).name}}
                </template>
              </td>
              <td v-if="false">
                <select name="" id="" v-model="entry.task_key">
                  <option :value="task['.key']" v-for="(task,i) in tasks" v-if="task.project_key == entry.project_key">{{task.title}}</option>
                </select>              
              </td>
              <td>
                <div v-if="false">
                  <select name="" id="" v-model="entry.worktype">
                    <option value="undefined">Vælg...</option>
                    <option :value="worktype.value" v-for="(worktype,i) in worktypes">{{worktype.title}}</option>
                  </select>                
                </div>
                <div class="label">Arbejdstype</div>
                <multiselect
                  :options="worktypes"
                  placeholder="Vælg..."
                  label="title"
                  select-label="" selected-label="" deselect-label=""
                  track-by="value"
                  :value="multiSelectGetOption(worktypes,'value',entry.worktype)"
                  @select="multiSelectOnSelect('worktype',$event,entry)"
                  :reset-after="false"
                ></multiselect>                            
              </td>
              <td>
                <div class="label">Note</div>
                <input type="text" _placeholder="" v-model="entry.title">
              </td>
              <td>
                <div class="checkbox">
                  <input type="checkbox" v-model="entry.billable" :id="'kj12b3kj+i'">
                  <label :for="'kj12b3kj'+i"></label>
                </div>
              </td>
              <td>
                <template v-if="!lineIsReady(i)"></template>
                <span v-if="lineIsReady(i)">
                  <svgicon icon="ionicons/checkmark"></svgicon>
                </span>
              </td>
              <td>
                <btn @click.native="dupeLineBelow(i)" color="secondary">
                  <svgicon icon="ionicons/ios-plus-empty"></svgicon>
                </btn>
              </td>
              <td>
                <btn @click.native="stripEntry(i)" color="secondary">
                  <svgicon icon="linearicons/cross"></svgicon>
                </btn>
              </td>
            </tr>
          </tbody>
        </table>

      <br>

      <div class="grid">
        <div class="col m50">
          <btn @click.native="addEmptyRow()" color="secondary" id="addrowbtn">
            Tilføj linje
          </btn>
          &nbsp;
          <btn v-if="false" @click.native="fetchLastProjects()" color="primary" id="fetchfromlatestprojects">Hent fra nyeste projekter</btn>
        </div>
        <div class="col m50 align-r">
          <btn @click.native="createNewTimelogs()" color="primary" :disabled="!somethingToSubmit()">Log {{getAddListTotalHoursCount()}} timers arbejde</btn>
        </div>
      </div>

    </template>



      <div class="killer" @click="closeTimelogger()">X</div>
    </div><!--popup-->

  </div>
</template>

<script>
import fdb from '.././firebase_config.js';
import moment from 'moment'
import auth from './../auth.js';
import mixins from '../mixins.js';
import helpers from '../helpers.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Inputfield from '.././components/Inputfield'
import './../components/generated_svg_icons/linearicons/trash'
import './../components/generated_svg_icons/linearicons/cross'
import './../components/generated_svg_icons/ionicons/checkmark'
import './../components/generated_svg_icons/ionicons/ios-plus-empty'
export default {
  components: { Box, Inputfield, Btn, },
  mixins: [ mixins.db, mixins.generic ],
  name: 'timelogger',
  data: function () {
    return {
      globals: this.$parent.globals,
      user: globals.user,
    }
  },
  computed: {

	worktypes(){
		var output = []
        for( var i = 0; i < globals.worktypes.length; i++ ) {
			var worktype = globals.worktypes[i]
      if( worktype.legacy ) continue
      output.push(worktype)
		}
		return output
	},

    addList(){ return globals.timelogger.addList },

    projectSelectOptions(){
      var output = []
      for( var project_key in this.$store.state.firebase.projects ) {
        var project = this.$store.state.firebase.projects[project_key]
        var client = this.$store.state.firebase.clients[project.client_key]
        var label = project.name
        if( client ) label = project.name + ' - ' + client.name

        if( !project.status || project.status == 'finished' ) continue

        //console.log(project_key)
        if(!project_key) continue
        if(project_key=='.key') continue
        output.push({
          value: project_key,
          label: label,
        })
      }
      //console.log(output)
      //return [{label:'joe',value:123},{label:'joge',value:1523},{label:'jeoe',value:1323}]
      return output
    },

  },//computed
  methods: {

    somethingToSubmit(){
      var totals = this.getAddListTotalHoursCount()
      if( totals == undefined ) return false
      if( totals == 0 ) return false
      return true
    },

    multiSelectOnSelect( instance, e, entry ){
      if( instance == 'project' ) this.$set(entry, 'project_key', e.value)
      if( instance == 'worktype' ) this.$set(entry, 'worktype', e.value)
    },

    multiSelectGetOption(options,key,val){
			if( !options ) return
			for( let option of options ) if( option[key] == val ) return option			
		},

    getUserbyUID: helpers.getUserbyUID,
    triggerIconSignal: helpers.triggerIconSignal,
	  getLastTimelogs: helpers.getLastTimelogs,


    createNewTimelogs(){
      
      var my_user_key = this.getUserbyUID(globals.user.uid)['.key']
      if(!my_user_key) return
      
      
      for( var i = 0; i < this.addList.length; i++ ) {
        var entry = this.addList[i]
        if( !this.lineIsReady(i) ) continue
        var new_timelog = {
          project_key: entry.project_key,
          //task_key: entry.task_key,
          worktype: entry.worktype,
          hours: entry.hours,
          date: entry.date,
          date_timestamp: moment(entry.date,'YYYY-MM-DD').unix(),
		      billable: entry.billable,
          created: moment().format('YYYY-MM-DD hh:mm:SS'),
          created_timestamp: moment().unix(),
          user_key: my_user_key,
        }
        if( entry.title ) new_timelog.title = entry.title
        fdb.ref('timelogs').push(new_timelog)
        entry.inserted = true
      }

      for( var i = 0; i < this.addList.length; i++ ) {
        var entry = this.addList[i]
        if(entry.inserted) this.stripEntry()
      }

      //globals.timelogger.addList = this.addList.filter(function(entry) { return !entry.inserted })

      this.closeTimelogger()
      this.triggerIconSignal('heart')

    },

    getAddListTotalHoursCount(){
      var count = 0
      for( var i = 0; i < this.addList.length; i++ ) {
        var entry = this.addList[i]
        if( !this.lineIsReady(i) ) continue
        count += entry.hours
      }
      return count
    },

    addEmptyRow(){
      globals.timelogger.addList.push({
        project_key: undefined,
        hours: 0,
		    billable: true,
        date: moment().format('YYYY-MM-DD'),
        title: undefined,
      })
    },


    stripEntry(i){
      globals.timelogger.addList.splice(i,1)
    },

    dupeLineBelow(i){
      var line = globals.timelogger.addList[i]
      var newLine = JSON.parse(JSON.stringify(line))
      globals.timelogger.addList.splice( i, 0, newLine )
      this.$set(entry, 'project_key', e.value)
    },

    lineIsReady(i){
      var row = this.addList[i]
      if( !row ) return false
      if( !row.project_key ) return false
      //if( !row.task_key ) return false
      if( !row.worktype ) return false
      if( !row.hours ) return false
      if( !row.title ) return false
      return true
    },

    getProject: helpers.getProject,
    getClient: helpers.getClient,

    resetLinesToDefaultState(){
      //globals.timelogger.addList = [
        //_.cloneDeep(globals.timelogger.emptyListItem)
      //]
    },

    openTimelogger(input){
      if( input && input['project_key'] ) {
        while(this.addList.length > 0) {
            globals.timelogger.addList.pop()
        }
          globals.timelogger.addList.push({
          project_key: input.project_key,
          hours: 1,
          date: moment().format('YYYY-MM-DD'),
		      billable: true,
        })
      }
      if( !this.addList.length ) eventBus.$emit('timelogger_addEmptyRow')
      globals.timelogger.visible = true
    },


	fetchLastProjects(){

		var lastTimelogs = this.getLastTimelogs(6)

		for( var i = 0; i < lastTimelogs.length; i++ ){
			var log = lastTimelogs[i]
			//console.log( log )
			  globals.timelogger.addList.push({
				project_key: log.project_key,
				billable: true,
	            date: moment().format('YYYY-MM-DD'),
			})
		}

	},

    closeTimelogger(){
      globals.timelogger.visible = false
    },

  },//methods
  created(){

    var _this = this

    eventBus.$on('timelogger_addEmptyRow', function (){ _this.addEmptyRow() })

    eventBus.$on('openTimelogger', function(input) { _this.openTimelogger(input) })
    eventBus.$on('closeTimelogger', function() { _this.closeTimelogger() })

  },//created

}
</script>



// WEBPACK FOOTER //
// Timelogger.vue?1afb502e